import { getHost } from './getHost';

export const isLocalHost = () => {
    return getHost().endsWith('.wip');
};
